import RichText from 'Shared/RichText/RichText'
import 'Styles/Background.scss'

const CancellationPolicies = ({ cancellationPolicies }) => (
  <div className="cancelation-policies">
    <p className="fw-bold">Please review the campground's cancellation policy:</p>

    <div className="bg-gray-light p-2 border rounded mb-3">
      <RichText className="text-smaller-1 fw-bold mb-0" html={cancellationPolicies.campgroundCancellationPolicy} />

      <small className="text-muted fst-italic mb-0">{cancellationPolicies.campgroundCancellationPolicyNote}</small>
    </div>

    <p className="fw-bold">Please review the RoverPass Cancellation Policy:</p>

    <div className="bg-gray-light p-2 border rounded mb-3">
      <RichText className="text-smaller-1 fw-bold mb-0" tag="span"
                html={cancellationPolicies.roverpassCancellationPolicy} />
    </div>
  </div>
)

export default CancellationPolicies
